import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { visuallyHidden } from '@mui/utils';
import useSetQuery from 'hooks/useSetQuery';
import useSearch from 'hooks/useSearch';

const BaseTableHead = ({ headCells, noActions }) => {
  const setQuery = useSetQuery();
  const query = useSearch();
  const { t } = useTranslation();

  const ordering = (name) => {
    if (query.get('order_field') === name) {
      if (query.get('order') === 'DESC') {
        setQuery('order', 'ASC');
      } else {
        setQuery('order');
        setQuery('order_field');
      }
    } else {
      setQuery('order', 'DESC');
      setQuery('order_field', name);
    }
  };

  const createSortHandler = (property) => {
    ordering(property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, headCellIndex) => (
          <Fragment key={'head-cell-' + headCell.code}>
            <TableCell
              align={headCell?.numeric ? 'right' : 'left'}
              padding={headCell?.disablePadding ? 'none' : 'normal'}
              sx={{ backgroundColor: '#F9F9F9', fontSize: '14px' }}
            >
              {headCell?.sortable ? (
                <TableSortLabel
                  active={query.get('order_field') === headCell?.code}
                  direction={
                    query.get('order_field') === headCell?.code
                      ? query.get('order')?.toLowerCase()
                      : 'asc'
                  }
                  className='[&_.MuiSvgIcon-root]:opacity-20 [&_.Mui-active_.MuiSvgIcon-root]:!opacity-100'
                  onClick={() => createSortHandler(headCell?.code)}
                >
                  {headCell?.label}
                  {query.get('order_field') === headCell?.code ? (
                    <Box component='span' sx={visuallyHidden}>
                      {query.get('order') === 'DESC'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                <div>{headCell?.label}</div>
              )}
            </TableCell>
          </Fragment>
        ))}
        {!noActions && (
          <TableCell padding='normal' align='right'>
            {t('common.table.actions')}
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

export default BaseTableHead;
